import React from 'react'

function CategoriesDetails() {
    return (
        <div>CategoriesDetails</div>
    )
}

export default CategoriesDetails